import tw, { styled } from 'twin.macro';
import Button from '@/components/Forms/components/FormButton/FormButton';

export const StyledSERPForm = styled.div`
  ${tw`p-4`}
  ${tw`bg-ui-colours-ui1`}
  ${tw`rounded-xl`}
`;

export const StyledFormHeadline = styled.h2`
  ${tw`font-poppins font-semi-bold md:font-bold`}
  ${tw`text-body-xl md:text-heading-m text-secondary-s1 text-center `}
  ${tw`pb-5 md:pb-2`}
`;

export const StyledFormFooter = styled.div`
  ${tw`pt-2`}
  ${tw`text-center`}
  ${tw`flex flex-col items-center gap-3`}
`;

export const StyledButton = styled(Button)`
  ${tw`whitespace-normal`}
`;

export const StyledForm = styled.form`
  ${tw`flex flex-col gap-2`}
`;
